export default __webpack_public_path__ + "static/media/2_0096.45525ea9.webp";